module.exports = __webpack_public_path__ + "img/authenticationGreen.ae1169d9.png";